import React from 'react';
import styled from 'styled-components';
import { useTheme, getFont } from '@24i/nxg-sdk-higgs';
import { rgbaToHex } from '@24i/nxg-core-utils';
export const Container = ({ children, fontName = 'body1' }) => {
    const { theme } = useTheme();
    const Div = styled.div `
        font-family: ${getFont(theme, fontName).fontFamily};
        font-weight: ${getFont(theme, fontName).fontWeight};
        text-align: center;
        color: ${rgbaToHex(theme.color.textPrimary)};
        margin-top: 42px;
    `;
    return React.createElement(Div, null, children);
};
//# sourceMappingURL=index.js.map